import { render } from "./CheckDetails.vue?vue&type=template&id=3e68be35"
import script from "./CheckDetails.vue?vue&type=script&lang=js"
export * from "./CheckDetails.vue?vue&type=script&lang=js"

import "./CheckDetails.vue?vue&type=style&index=0&id=3e68be35&lang=css"

import exportComponent from "/home/zhayrullah/projects/laravel/mawthuq/front-mawthuq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__